import find from "lodash/find"
import times from "lodash/times"
import filter from "lodash/filter"
import random from "lodash/random"
import findIndex from "lodash/findIndex"

import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    stores: [],
    jobs: [],
    issues: [],
    issue_types: [],
    issue_photos: [],
    user: null,
    selected_store: -1,
    selected_job: -1,
    toasts: [],
  },
  getters: {
    store (state) {
      return find(state.stores, {id: state.selected_store});
    },
    job (state) {
      return find(state.jobs, {id: state.selected_job});
    },
    issues (state, getters) {
      if (!getters.job) {
        return [];
      }
      return filter(state.issues, {job: getters.job.id});
    },
    issue_types (state) {
      return state.issue_types;
    },
    issue_photos (state) {
      return state.issue_photos;
    },
    logged_in (state) {
      return state.user !== null && state.user.authed;
    },
    toasts (state) {
      return state.toasts;
    },
  },
  mutations: {
    set_stores (state, stores) {
      state.stores = stores;
      localStorage.setItem("stores", JSON.stringify(stores));
    },
    set_jobs (state, jobs) {
      state.jobs = jobs;
    },
    set_issues (state, issues) {
      state.issues = issues;
    },
    set_issue_types (state, types) {
      state.issue_types = types;
      localStorage.setItem("issue_types", JSON.stringify(types));
    },
    set_issue_photos (state, photos) {
      state.issue_photos = photos;
    },
    add_job (state, job) {
      state.jobs.push(job);
    },
    replace_job (state, job) {
      for (let i = 0; i < state.jobs.length; i++) {
        let j = state.jobs[i];
        if (j.id === job.id) {
          state.jobs.splice(i, 1, job);
          break;
        }
      }
    },
    remove_job (state, job) {
      for (let i = 0; i < state.jobs.length; i++) {
        let j = state.jobs[i];
        if (j.id === job.id) {
          state.jobs.splice(i, 1);
          break;
        }
      }
    },
    add_issue (state, issue) {
      state.issues.push(issue);
    },
    replace_issue (state, issue) {
      for (let i = 0; i < state.issues.length; i++) {
        let j = state.issues[i];
        if (j.id === issue.id) {
          state.issues.splice(i, 1, issue);
          break;
        }
      }
    },
    remove_issue (state, issue) {
      for (let i = 0; i < state.issues.length; i++) {
        let j = state.issues[i];
        if (j.id === issue.id) {
          state.issues.splice(i, 1);
          break;
        }
      }
    },
    add_issue_photo (state, photo) {
      state.issue_photos.push(photo);
    },
    remove_issue_photo (state, photo) {
      for (let i = 0; i < state.issue_photos.length; i++) {
        let j = state.issue_photos[i];
        if (j.id === photo.id) {
          state.issue_photos.splice(i, 1);
          break;
        }
      }
    },
    select_store (state, store_id) {
      state.selected_store = parseInt(store_id);
    },
    select_job (state, job_id) {
      state.selected_job = parseInt(job_id);
    },
    set_user (state, user) {
      state.user = user;
    },
    add_toast(state, {message, time, type}) {
      if (!time) {
        time = 3;
      }
      if (!type) {
        type = "success";
      }
      let id = times(6, () => random(35).toString(36)).join('');
      state.toasts.push({
        id,
        message,
        time,
        type,
      });
    },
    remove_toast(state, id) {
      state.toasts.splice(findIndex(state.toasts, {id}), 1);
    },
  },
  actions: {
    async get_stores ({commit, state}, lazy) {
      if (lazy && state.stores.length) {
        return;
      }

      let saved_stores = localStorage.getItem("stores");
      if (saved_stores !== null) {
        commit("set_stores", JSON.parse(saved_stores));
      }

      let stores = await (await Vue.http.get("/rest/1.0/lean/stores/")).json();
      commit("set_stores", stores);
    },
    async get_jobs ({commit, state}, {store_id, job_id, lazy}) {
      if (lazy && state.jobs.length) {
        return;
      }
      let jobs = [];
      if (store_id) {
        jobs = await (await Vue.http.get(
          "/rest/1.0/log/jobs/", {
            params: {
              store: store_id
            }
          }
        )).json();
      } else if (job_id) {
        let job = await (
          await Vue.http.get("/rest/1.0/log/jobs/" + job_id + "/")
        ).json();
        jobs.push(job);
      }
      commit("set_jobs", jobs);
    },
    async get_issues ({commit}, {store_id, job_id, lazy}) {
      if (lazy && state.issues.length) {
        return;
      }
      let filter = {};
      if (store_id) {
        filter.job__store = store_id;
      }
      if (job_id) {
        filter.job = job_id;
      }
      let issues = await (await Vue.http.get(
        "/rest/1.0/log/issues/", {
          params: filter
        }
      )).json();
      commit("set_issues", issues);
    },
    async get_issue_photos ({commit}, {store_id, job_id, issue_id, lazy}) {
      if (lazy && state.issue_photos.length) {
        return;
      }
      let filter = {};
      if (store_id) {
        filter.issue__job__store = store_id;
      }
      if (job_id) {
        filter.issue__job = job_id;
      }
      if (issue_id) {
        filter.issue = issue_id;
      }
      let issues = await (await Vue.http.get(
        "/rest/1.0/log/issue-photos/", {
          params: filter
        }
      )).json();
      commit("set_issue_photos", issues);
    },
    async get_issue_types ({commit}) {
      let saved_types = localStorage.getItem("issue_types");
      if (saved_types !== null) {
        commit("set_issue_types", JSON.parse(saved_types));
      }

      let types = await (await Vue.http.get("/rest/1.0/log/issue-types/")).json();
      commit("set_issue_types", types);
    },
    async new_job({commit}, job) {
      let new_job = await (await Vue.http.post("/rest/1.0/log/jobs/",
        job
      )).json();
      commit("add_job", new_job);
      return new_job;
    },
    async delete_job ({commit}, job) {
      await Vue.http.delete("/rest/1.0/log/jobs/" + job.id + "/");
      commit("remove_job", job);
    },
    async new_issue ({commit}, issue) {
      let new_issue = await (await Vue.http.post("/rest/1.0/log/issues/", issue)).json();
      commit("add_issue", new_issue);
      return new_issue;
    },
    async update_issue ({commit}, issue) {
      let updated_issue = await (await Vue.http.put("/rest/1.0/log/issues/" + issue.id + "/", issue)).json();
      commit("replace_issue", updated_issue);
      return updated_issue;
    },
    async delete_issue ({commit}, issue) {
      await Vue.http.delete("/rest/1.0/log/issues/" + issue.id + "/");
      commit("remove_issue", issue);
    },
    async delete_issue_photo ({commit}, photo) {
      await Vue.http.delete("/rest/1.0/log/issue-photos/" + photo.id + "/");
      commit("remove_issue_photo", photo);
    },
    async set_job_urgency ({commit}, {job_id, urgency_days, urgent}) {
      let job = await (await Vue.http.patch("/rest/1.0/log/jobs/" + job_id + "/", {
        urgent,
        urgency_days
      })).json();
      commit("replace_job", job);
    },
    async submit_job ({commit}, job_id) {
      let job = await (await Vue.http.patch("/rest/1.0/log/jobs/" + job_id + "/", {
        submitted: true
      })).json();
      commit("replace_job", job);
    },
    async get_user_info ({commit}) {
      let user_info = await (await Vue.http.get("/api/login/user/info/")).json();
      commit("set_user", user_info);
    },
  }
});

export default store;



// WEBPACK FOOTER //
// ./assets/js/store.js